window.addEventListener('load', function () {
    var grid       = document.getElementById('design-notes-grid');
    var emptyMsg   = document.getElementById('design-notes-empty');
    var resetBtn   = document.getElementById('design-notes-reset');
    var searchEl   = document.getElementById('design-notes-search');
    var filterBtns = Array.from(document.querySelectorAll('.design-note-filter-btn'));

    if (!grid) return;

    var cards       = Array.from(grid.querySelectorAll('[data-design-note-card]'));
    var searchQuery = '';

    // Valid types derived from rendered buttons (CMS-driven — no hardcoding)
    var validTypes = filterBtns
        .map(function (b) { return b.dataset.filter; })
        .filter(function (f) { return f !== 'all'; });

    var urlType      = new URLSearchParams(window.location.search).get('type');
    var activeFilter = (urlType && validTypes.indexOf(urlType) !== -1) ? urlType : 'all';

    // --- Helpers ---

    function setActiveBtn(value) {
        filterBtns.forEach(function (btn) {
            btn.setAttribute('aria-selected', btn.dataset.filter === value ? 'true' : 'false');
        });
    }

    function updateUrl(value) {
        var url = new URL(window.location.href);
        if (value === 'all') {
            url.searchParams.delete('type');
        } else {
            url.searchParams.set('type', value);
        }
        window.history.replaceState(null, '', url.toString());
    }

    function applyFilters() {
        var visible = 0;
        cards.forEach(function (card) {
            // data-note-type is space-separated slugs (supports multi-category)
            var types     = (' ' + (card.dataset.noteType || '') + ' ');
            var text      = card.textContent.toLowerCase();
            var matchType = activeFilter === 'all' || types.indexOf(' ' + activeFilter + ' ') !== -1;
            var matchText = !searchQuery || text.indexOf(searchQuery) !== -1;
            card.hidden   = !(matchType && matchText);
            if (!card.hidden) visible++;
        });
        if (emptyMsg) emptyMsg.hidden = visible > 0;
        updateUrl(activeFilter);
    }

    // --- Initialise from URL param ---

    setActiveBtn(activeFilter);
    if (activeFilter !== 'all') applyFilters();

    // --- Button clicks ---

    filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            activeFilter = btn.dataset.filter;
            setActiveBtn(activeFilter);
            applyFilters();
        });
    });

    // --- Live search ---

    if (searchEl) {
        searchEl.addEventListener('input', function () {
            searchQuery = searchEl.value.toLowerCase().trim();
            applyFilters();
        });
    }

    // --- Reset ---

    if (resetBtn) {
        resetBtn.addEventListener('click', function () {
            activeFilter = 'all';
            searchQuery  = '';
            if (searchEl) searchEl.value = '';
            setActiveBtn('all');
            applyFilters();
        });
    }
});
